import { findSubserviceAcrossTrades } from '../constants/mockData/allTrades';
import {
  isCustomSubServiceType,
  resolveSubserviceTitle,
} from './subserviceDisplay';

function titleCaseSlug(slug) {
  if (!slug || typeof slug !== 'string') return 'Service';
  return slug
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/** Human-readable label from `custom-{nameSlug}-{id}` when Title is unavailable. */
function labelFromCustomSlug(slug) {
  if (!isCustomSubServiceType(slug)) return slug;
  const parts = slug.slice('custom-'.length).split('-');
  if (parts.length < 2) return titleCaseSlug(slug);
  parts.pop();
  const namePart = parts.join('-');
  return namePart ? titleCaseSlug(namePart) : titleCaseSlug(slug);
}

/**
 * Human-readable subservice name for UI: enrolled custom Title, catalog label, then slug.
 * @param {string | null | undefined} subServiceTypeSlug Cosmos / wizard `subServiceType`
 * @param {{ serviceType?: string, enrolledServices?: Array<{ ServiceType?: string, SubServices?: Array<{ SubServiceType?: string, Title?: string, IsCustom?: boolean }> }> }} [options]
 * @returns {string | undefined}
 */
export function getSubserviceDisplayLabel(subServiceTypeSlug, options) {
  if (subServiceTypeSlug == null) return undefined;
  const slug = String(subServiceTypeSlug).trim();
  if (!slug) return undefined;

  const serviceType = options?.serviceType;
  const enrolledServices = options?.enrolledServices;
  if (serviceType && Array.isArray(enrolledServices)) {
    const svc = enrolledServices.find((s) => s?.ServiceType === serviceType);
    const sub = svc?.SubServices?.find((s) => s?.SubServiceType === slug);
    if (sub) {
      return resolveSubserviceTitle(serviceType, sub);
    }
  }

  const fromTradeCatalog = findSubserviceAcrossTrades(slug)?.subservice?.label;
  if (fromTradeCatalog) return fromTradeCatalog;

  if (isCustomSubServiceType(slug)) {
    return labelFromCustomSlug(slug);
  }

  return titleCaseSlug(slug);
}
